import { render } from "./UiMusicMixer.vue?vue&type=template&id=ca577484&scoped=true"
import script from "./UiMusicMixer.vue?vue&type=script&lang=js"
export * from "./UiMusicMixer.vue?vue&type=script&lang=js"

import "./UiMusicMixer.vue?vue&type=style&index=0&id=ca577484&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca577484"]])

export default __exports__